import { Spacing, Text } from '@vkontakte/vkui';
import unlimImgPromo from 'img/quota-landing/beautifulIllustrations/septemberPromo2025Unlim.png';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PROMO_TARIFFS } from 'reactApp/appHelpers/configHelpers';
import { helpAutoUploadHref } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import type { RootState } from 'reactApp/store';
import type { Product } from 'reactApp/types/Billing';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';

import styles from './SeptemberPromo2025UnlimitBlock.css';

export const SeptemberPromo2025UnlimitBlock = () => {
    const dispatch = useDispatch();
    const product = useSelector((state: RootState) =>
        ProductsSelectors.getProductById(state, PROMO_TARIFFS?.unlimitedUploadPromo)
    ) as Product;

    const buttonText = useMemo(() => {
        if (!product) {
            return '';
        }

        return `Подключить ${product.space.value}`;
    }, [product]);

    const handleClick = useCallback(() => {
        dispatch(
            openTariffBuy({
                productId: product?.id,
                checkAnonymous: true,
                paySource: 'september2025',
            })
        );
    }, [product]);

    return (
        <div className={styles.promoBlock}>
            <img className={styles.image} src={unlimImgPromo} alt="Безлимит" />
            <div className={styles.promoContent}>
                <Text className={styles.promoTitle}>Безлимит для фото и&nbsp;видео</Text>
                <Spacing size={16} />
                <Text className={styles.promoText}>
                    Или безлимитная автозагрузка&nbsp;&mdash; это расширенная возможность обычной автозагрузки.
                </Text>
                <Spacing size={16} />
                <div className={styles.promoCardsBlock}>
                    <div className={styles.card}>
                        С&nbsp;обычной фото и&nbsp;видео с&nbsp;телефона переносятся в&nbsp;Облако и&nbsp;занимают в&nbsp;нём гигабайты
                    </div>
                    <div className={styles.card}>
                        А&nbsp;с&nbsp;безлимитной&nbsp;&mdash; нет. Безлимит доступен в&nbsp;тарифах от&nbsp;256&nbsp;ГБ
                    </div>
                </div>
                <Spacing size={24} />
                <div className={styles.promoButtonsBlock}>
                    {Boolean(buttonText) && (
                        <Button theme="vk" sizeMode={ButtonSizeMode.extraBig} className={styles.button} onClick={handleClick}>
                            {buttonText}
                        </Button>
                    )}
                    {Boolean(helpAutoUploadHref) && (
                        <div className={styles.promoTextLinkBlock}>
                            Подробнее{' '}
                            <a href={helpAutoUploadHref} className={styles.link} target="_blank" rel="noopener noreferrer">
                                в&nbsp;статье
                            </a>{' '}
                            &laquo;Как включить безлимитную автозагрузку файлов с&nbsp;телефона в&nbsp;Облако Mail&raquo;
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

SeptemberPromo2025UnlimitBlock.displayName = 'SeptemberPromo2025UnlimitBlock';
